export const isValidVin = (vin?: string): boolean => {
  if (!vin) {
    return false;
  }

  return /^[A-HJ-NPR-Z0-9]{11,17}$/.test(vin);
};
